import { z } from 'zod';
import { ESTADOS_ORDEN_DTO } from './ordenes.js';
/**
 * La campana: qué pasó con las órdenes que a uno le tocan.
 *
 * NO hay una entidad «notificación» en la base. Cada fila de acá es un
 * `OrdenEvento` —la emisión, un cambio de estado, el avance derivado de sus
 * líneas, una confirmación parcial, una propuesta de ajuste, el visto bueno del
 * cliente— proyectado según quién pregunta. Duplicar esos hechos en una tabla
 * aparte habría significado dos versiones de la misma historia, y la campana
 * diciendo algo distinto de la ficha de la orden.
 *
 * TRES CUENTAS, TRES ALCANCES, LA MISMA FORMA. El equipo ve todo; un cliente,
 * las órdenes de su empresa; un proveedor, las que tocan sus productos. El
 * filtro es el mismo `filtroOrdenes` que rige el resto de la API, así que la
 * campana no puede mostrar nada que su dueño no pueda abrir.
 */
export const esquemaNotificacion = z.object({
    /** Id del evento. Estable, sirve de clave de lista. */
    id: z.string(),
    ordenId: z.string(),
    /** Número visible de la orden: es como la persona la nombra. */
    numero: z.string(),
    /**
     * Título compuesto por el SERVIDOR desde la transición, nunca texto libre.
     *
     * Es lo que hace que la misma fila se pueda mostrar a los tres alcances sin
     * revisar qué dice: «Orden despachada», «Orden confirmada». El texto libre va
     * en `detalle`, que sí depende de quién pregunta.
     */
    titulo: z.string(),
    /**
     * La nota del evento, cuando corresponde mostrarla.
     *
     * `null` para un PROVEEDOR aunque el evento tenga nota: ahí viven cosas como
     * «Propuesta enviada al cliente (ronda 2): bajamos 3 unidades», que es la
     * negociación entre el equipo y la minera y no le corresponde leerla. Un
     * cliente y el equipo sí la ven.
     */
    detalle: z.string().nullable(),
    estadoAnterior: z.enum(ESTADOS_ORDEN_DTO).nullable(),
    estadoNuevo: z.enum(ESTADOS_ORDEN_DTO),
    /**
     * A dónde lleva al pulsarla. Lo decide el SERVIDOR y no el navegador.
     *
     * Un cliente y el equipo van a la ficha de la orden; un proveedor va a su
     * lista de órdenes recibidas, porque la ficha de orden es la vista del
     * comprador. Calcularlo acá y no en la interfaz evita que la campana ofrezca
     * un destino que ese rol no puede abrir.
     */
    enlace: z.string(),
    creadoEn: z.string(),
    /** Si es posterior a la última vez que abrió la campana. */
    noLeida: z.boolean(),
});
export const esquemaPaginaNotificaciones = z.object({
    datos: z.array(esquemaNotificacion),
    /**
     * Cuántas hay sin leer, que es el número del globo.
     *
     * Se cuenta aparte del listado y con su propio tope: la campana muestra las
     * últimas veinte, pero el contador tiene que poder decir «hay más de veinte»
     * sin traerlas todas.
     */
    noLeidas: z.number().int(),
    /** El contador se saturó en este número. La interfaz pinta «20+». */
    saturado: z.boolean(),
});
//# sourceMappingURL=notificaciones.js.map